import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export function SortableItem({ id, option, index, onRemove }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id,
    // Verhindert Scroll beim Drag auf mobilen Geräten
    transition: {
      duration: 150,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "18px 20px 18px 18px",
    borderRadius: 14,
    border: isDragging ? "3px solid #7c4dff" : "2px solid #E9E4E3",
    background: isDragging 
      ? "linear-gradient(135deg, #e8e1ff 0%, #f0ebff 100%)" 
      : "linear-gradient(135deg, #ffffff 0%, #fafafa 100%)",
    fontWeight: 600,
    fontSize: "1rem",
    display: "flex",
    alignItems: "center",
    boxShadow: isDragging 
      ? "0 12px 32px rgba(124, 77, 255, 0.35)" 
      : "0 3px 10px rgba(0, 0, 0, 0.08)",
    marginBottom: 0,
    cursor: isDragging ? 'grabbing' : 'default',
    userSelect: 'none',
    touchAction: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    position: 'relative',
    minHeight: '64px'
  };

  return (
    <div ref={setNodeRef} className="ranking-item" style={style} {...attributes}>
      {/* Entfernen-Button in der oberen rechten Ecke */}
      <button
        className="ranking-item-remove"
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          border: "none",
          background: "#ff4757",
          color: "#fff",
          borderRadius: "50%",
          padding: 0,
          cursor: "pointer",
          fontWeight: 700,
          fontSize: 12,
          transition: "all 0.2s ease",
          boxShadow: "0 2px 6px rgba(255, 71, 87, 0.3)",
          width: "26px",
          height: "26px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10
        }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onRemove();
        }}
        onMouseOver={(e) => {
          e.target.style.background = "#ff3838";
          e.target.style.transform = "scale(1.1)";
          e.target.style.boxShadow = "0 3px 10px rgba(255, 71, 87, 0.5)";
        }}
        onMouseOut={(e) => {
          e.target.style.background = "#ff4757";
          e.target.style.transform = "scale(1)";
          e.target.style.boxShadow = "0 2px 6px rgba(255, 71, 87, 0.3)";
        }}
      >
        ✕
      </button>

      {/* Content Container */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        flex: 1,
        gap: '16px',
      }}>
        <span className="ranking-item-index" style={{
          color: "#7c4dff",
          fontWeight: 800,
          fontSize: "1.3rem",
          minWidth: 32,
          textAlign: "center",
          background: "linear-gradient(135deg, #f0ebff 0%, #e8e1ff 100%)",
          borderRadius: "8px",
          padding: "6px 8px",
          border: "2px solid #7c4dff",
          boxShadow: "0 2px 6px rgba(124, 77, 255, 0.2)"
        }}>
          {index + 1}
        </span>
        
        <span className="ranking-item-text" style={{ 
          flex: 1,
          lineHeight: 1.5,
          color: "#333"
        }}>
          {option}
        </span>
      </div>

      {/* Sortier-Handle rechts */}
      <div 
        className="ranking-item-handle"
        style={{
          color: "#7c4dff",
          fontSize: 22,
          userSelect: "none",
          cursor: isDragging ? "grabbing" : "grab",
          padding: "14px 18px",
          borderRadius: 10,
          background: isDragging 
            ? "linear-gradient(135deg, #7c4dff 0%, #6a3de8 100%)" 
            : "linear-gradient(135deg, rgba(124, 77, 255, 0.12) 0%, rgba(124, 77, 255, 0.18) 100%)",
          border: "2px solid rgba(124, 77, 255, 0.4)",
          transition: "all 0.2s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "52px",
          minHeight: "52px",
          touchAction: 'none',
          WebkitTouchCallout: 'none',
          WebkitUserSelect: 'none',
          fontWeight: 700,
          boxShadow: isDragging 
            ? "0 4px 12px rgba(124, 77, 255, 0.4)" 
            : "0 2px 6px rgba(124, 77, 255, 0.2)"
        }}
        {...listeners}
        onMouseOver={(e) => {
          if (!isDragging) {
            e.currentTarget.style.background = "linear-gradient(135deg, rgba(124, 77, 255, 0.25) 0%, rgba(124, 77, 255, 0.35) 100%)";
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "0 3px 10px rgba(124, 77, 255, 0.35)";
          }
        }}
        onMouseOut={(e) => {
          if (!isDragging) {
            e.currentTarget.style.background = "linear-gradient(135deg, rgba(124, 77, 255, 0.12) 0%, rgba(124, 77, 255, 0.18) 100%)";
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(124, 77, 255, 0.2)";
          }
        }}
        onTouchStart={(e) => {
          e.currentTarget.style.background = "linear-gradient(135deg, rgba(124, 77, 255, 0.25) 0%, rgba(124, 77, 255, 0.35) 100%)";
        }}
        onTouchEnd={(e) => {
          if (!isDragging) {
            e.currentTarget.style.background = "linear-gradient(135deg, rgba(124, 77, 255, 0.12) 0%, rgba(124, 77, 255, 0.18) 100%)";
          }
        }}
      >
        ⋮⋮
      </div>
    </div>
  );
}